// Config option kỳ tính
export default {
  // Qúy
  FiscalI: 100, // Qúy 1
  FiscalII: 200,
  FiscalIII: 300,
  FiscalIV: 400,
  Year: 500, // Cả năm
};
